import { STATION_DOWNTIME_REPORT, STATION_DOWNTIME_REPORT_FAIL, STATION_DOWNTIME_REPORT_SUCCESS } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  stationDownTimeReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 0,
};

const stationDownTimeReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STATION_DOWNTIME_REPORT: {
      return { ...state, isLoading: true };
    }
    case STATION_DOWNTIME_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        stationDownTimeReport: payload?.results,
        page: payload?.page,
        limit: payload?.limit,
        totalPages: payload?.totalPages,
        total: payload?.totalResults,
        uptime: payload?.avgUptime,
        uptimeIncludingWS: payload?.avgUptimeIncludingWs,
      };
    }

    case STATION_DOWNTIME_REPORT_FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default stationDownTimeReportReducer;
